const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;

export const ACTIVITY_TRACKER_TIMEOUT_MS = import.meta.env.PROD ? 15 * MINUTE_MS : 3 * MINUTE_MS;
export const ACTIVITY_TRACKER_WARNING_TIME_MS = import.meta.env.PROD
    ? 1 * MINUTE_MS
    : 15 * SECOND_MS;
export const FORM_LOCK_EXTENSION_INTERVAL_MS = import.meta.env.PROD
    ? 15 * MINUTE_MS
    : 1 * MINUTE_MS;
export const DRAFT_AUTOSAVE_INTERVAL_MS = 1 * MINUTE_MS;
